var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.appReady
    ? _c(
        "div",
        { attrs: { id: "app" } },
        [
          [
            _c("router-view"),
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "loading-container" },
                  [
                    _c("b-spinner", {
                      style: { width: "80px", height: "80px" },
                      attrs: { variant: "primary" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
        ],
        2
      )
    : _c("div", { staticClass: "text-center pt-3" }, [_c("b-spinner")], 1)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }